const DefaultMainState = {
  expanded: false
};

export const MainState = { data: DefaultMainState }